import React from 'react';
import './RegisterHero.css';

const RegisterHero = () => {
  return (
    <section className="register-hero">
      <div className="container">
        <div className="register-hero-content">
          <h1 className="register-title">
            Register
          </h1>
          <p className="register-subtitle">
            Create a new Account for your company
          </p>
        </div>
      </div>
    </section>
  );
};

export default RegisterHero;
